<div class="wbs-container">
  <div class="wbs-header">
    <div class="header-left">
      <h1 class="wbs-title">{{ isBidderView ? 'My Allocated Work' : 'Project Planner' }}</h1>
      <p *ngIf="isBidderView" class="bidder-view-hint">
        Activities allocated to your organization
        <span *ngIf="parentOrgName"> by {{ parentOrgName }}</span>
      </p>
      <div class="project-info" *ngIf="projectName">
        <span class="project-name">{{ projectName }}</span>
      </div>
      <div class="wbs-stats" *ngIf="!isLoading">
        <span class="stat-chip">{{ activityCount }} {{ activityCount === 1 ? 'activity' : 'activities' }}</span>
        <span class="stat-chip">{{ overallPercent }}% average complete</span>
        <!-- <span class="stat-chip" [class.stat-warn]="unassignedOrgCount > 0" *ngIf="!isBidderView">
          {{ unassignedOrgCount ? unassignedOrgCount + ' unassigned org' + (unassignedOrgCount === 1 ? '' : 's') : 'All orgs assigned' }}
        </span> -->
      </div>
    </div>
    <div class="header-right">
      <app-back-button
        label="Back to Projects"
        [link]="['/projects']"
        class="action-btn">
      </app-back-button>
      <button *ngIf="!isBidderView" mat-stroked-button type="button" (click)="viewDeviationReport()" class="action-btn">
        <mat-icon>assessment</mat-icon> Deviation Report
      </button>
      <button *ngIf="!isBidderView" mat-raised-button color="primary" type="button" (click)="openAddForm()" class="action-btn">
        <mat-icon>add</mat-icon> Add Activity
      </button>
    </div>
  </div>

  <!-- Activity Form Modal -->
  <div class="form-overlay" *ngIf="showForm" (click)="closeForm()">
    <div class="form-container" (click)="$event.stopPropagation()">
      <div class="form-header">
        <div>
          <h2>{{ isBidderView ? 'Update progress' : (editingActivity ? 'Edit Activity' : 'Add New Activity') }}</h2>
          <p class="form-subtitle" *ngIf="editingActivity">{{ editingActivity.activity_name }}</p>
        </div>
        <button mat-icon-button type="button" (click)="closeForm()" aria-label="Close">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <form [formGroup]="activityForm" (ngSubmit)="saveActivity()">
        <div class="form-content">
          <div class="form-section" *ngIf="!isBidderView">
            <div class="form-section-title">
              <mat-icon>info</mat-icon>
              Basic Information
            </div>

            <div class="wbs-field">
              <label class="wbs-field-label" for="wbs-activity-name">Activity name <span class="req">*</span></label>
              <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic" hideRequiredMarker>
                <input id="wbs-activity-name" matInput formControlName="activity_name" required>
                <mat-error *ngIf="activityForm.get('activity_name')?.hasError('required')">
                  Activity name is required
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-row">
              <div class="wbs-field">
                <label class="wbs-field-label" for="wbs-activity-code">Activity code</label>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <input id="wbs-activity-code" matInput formControlName="activity_code" placeholder="e.g. ACT001">
                </mat-form-field>
              </div>

              <div class="wbs-field">
                <label class="wbs-field-label">Assigned to</label>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-select formControlName="assigned_to" placeholder="Select staff" [disabled]="isLoadingStaff">
                    <mat-option *ngIf="isLoadingStaff" disabled>Loading staff...</mat-option>
                    <mat-option [value]="null">None</mat-option>
                    <mat-option *ngFor="let staff of staffList" [value]="staff.id || staff.personnel_id || staff.full_name">
                      {{ staff.full_name || (staff.first_name + ' ' + staff.last_name) }}
                      <span *ngIf="staff.contact_email"> ({{ staff.contact_email }})</span>
                    </mat-option>
                    <mat-option *ngIf="!isLoadingStaff && staffList.length === 0" disabled>
                      No staff members found
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="wbs-field">
              <label class="wbs-field-label" for="wbs-description">Description</label>
              <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
                <textarea id="wbs-description" matInput formControlName="description" rows="3" placeholder="Optional notes"></textarea>
              </mat-form-field>
            </div>

            <div class="wbs-field" *ngIf="!isBidderView">
              <label class="wbs-field-label">Assigned organization</label>
              <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
                <mat-select formControlName="assigned_org_id" placeholder="Optional — allocate to a bidder or contractor" [disabled]="isLoadingAssignableOrgs">
                  <mat-option *ngIf="isLoadingAssignableOrgs" disabled>Loading organizations…</mat-option>
                  <mat-option [value]="null">None</mat-option>
                  <mat-option *ngFor="let org of assignableOrganizations" [value]="org.org_id">
                    {{ org.org_name }}
                  </mat-option>
                </mat-select>
                <mat-hint>Awarded bidders appear first. Allocate activities so they show on the bidder dashboard.</mat-hint>
              </mat-form-field>
            </div>
          </div>

          <div class="form-section" *ngIf="!isBidderView">
            <div class="form-section-title">
              <mat-icon>event</mat-icon>
              Planned Schedule
            </div>
            <div class="form-row">
              <div class="wbs-field">
                <label class="wbs-field-label">Plan start <span class="req">*</span></label>
                <mat-form-field appearance="outline" subscriptSizing="dynamic" hideRequiredMarker>
                  <input matInput [matDatepicker]="planStartPicker" formControlName="plan_start_date" required>
                  <mat-datepicker-toggle matSuffix [for]="planStartPicker"></mat-datepicker-toggle>
                  <mat-datepicker #planStartPicker></mat-datepicker>
                  <mat-error *ngIf="activityForm.get('plan_start_date')?.hasError('required')">
                    Plan start date is required
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="wbs-field">
                <label class="wbs-field-label">Plan end <span class="req">*</span></label>
                <mat-form-field appearance="outline" subscriptSizing="dynamic" hideRequiredMarker>
                  <input matInput [matDatepicker]="planEndPicker" formControlName="plan_end_date" required>
                  <mat-datepicker-toggle matSuffix [for]="planEndPicker"></mat-datepicker-toggle>
                  <mat-datepicker #planEndPicker></mat-datepicker>
                  <mat-error *ngIf="activityForm.get('plan_end_date')?.hasError('required')">
                    Plan end date is required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="form-section">
            <div class="form-section-title">
              <mat-icon>check_circle</mat-icon>
              Actual Progress
            </div>
            <div class="form-row">
              <div class="wbs-field">
                <label class="wbs-field-label">Actual start</label>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <input matInput [matDatepicker]="actualStartPicker" formControlName="actual_start_date">
                  <mat-datepicker-toggle matSuffix [for]="actualStartPicker"></mat-datepicker-toggle>
                  <mat-datepicker #actualStartPicker></mat-datepicker>
                </mat-form-field>
              </div>

              <div class="wbs-field">
                <label class="wbs-field-label">Actual end</label>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <input matInput [matDatepicker]="actualEndPicker" formControlName="actual_end_date">
                  <mat-datepicker-toggle matSuffix [for]="actualEndPicker"></mat-datepicker-toggle>
                  <mat-datepicker #actualEndPicker></mat-datepicker>
                </mat-form-field>
              </div>
            </div>

            <div class="form-row">
              <div class="wbs-field">
                <label class="wbs-field-label" for="wbs-percent">Percent complete</label>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <input id="wbs-percent" matInput type="number" formControlName="percent_complete" min="0" max="100">
                  <span matSuffix>%</span>
                  <mat-hint>0–100</mat-hint>
                  <mat-error *ngIf="activityForm.get('percent_complete')?.hasError('min') || activityForm.get('percent_complete')?.hasError('max')">
                    Value must be between 0 and 100
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="wbs-field" *ngIf="isBidderView">
                <label class="wbs-field-label">Assigned to</label>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-select formControlName="assigned_to" placeholder="Select staff" [disabled]="isLoadingStaff">
                    <mat-option *ngIf="isLoadingStaff" disabled>Loading staff...</mat-option>
                    <mat-option [value]="null">None</mat-option>
                    <mat-option *ngFor="let staff of staffList" [value]="staff.id || staff.personnel_id || staff.full_name">
                      {{ staff.full_name || (staff.first_name + ' ' + staff.last_name) }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="wbs-field" *ngIf="!isBidderView">
                <label class="wbs-field-label" for="wbs-order">Display order</label>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <input id="wbs-order" matInput type="number" formControlName="activity_order">
                  <mat-hint>Lower numbers appear first</mat-hint>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        <div class="form-actions">
          <button mat-stroked-button type="button" (click)="closeForm()">Cancel</button>
          <button mat-raised-button color="primary" type="submit" [disabled]="activityForm.invalid">
            {{ isBidderView ? 'Save progress' : (editingActivity ? 'Update' : 'Create') }}
          </button>
        </div>
      </form>
    </div>
  </div>

  <div class="table-container">
    <div class="table-toolbar">
      <div class="toolbar-left">
        <h2 class="table-title">Work Breakdown Structure</h2>
        <div class="search-box">
          <mat-icon>search</mat-icon>
          <input type="text" (keyup)="applyFilter($event)" placeholder="Search activities">
        </div>
      </div>
      <div class="toolbar-right" *ngIf="!isBidderView">
        <input type="file" #fileInput accept=".xlsx,.xls" (change)="onFileSelected($event)" hidden>
        <button mat-stroked-button type="button" (click)="fileInput.click()" class="import-btn">
          <mat-icon>upload_file</mat-icon> Choose file
        </button>
        <span class="file-name" *ngIf="selectedFile" [title]="selectedFile.name">{{ selectedFile.name }}</span>
        <button mat-stroked-button color="primary" type="button" (click)="importExcel()"
                [disabled]="!selectedFile || isImporting" class="import-btn">
          <mat-icon>import_export</mat-icon> {{ isImporting ? 'Importing…' : 'Import' }}
        </button>
        <button mat-stroked-button type="button" (click)="exportExcel()" class="import-btn">
          <mat-icon>download</mat-icon> Export
        </button>
      </div>
    </div>
    <p class="import-hint" *ngIf="!isBidderView">Export a spreadsheet as a template, update rows, then import to add or refresh activities.</p>

    <div class="table-loading" *ngIf="isLoading">
      <mat-spinner diameter="36"></mat-spinner>
      <span>Loading activities…</span>
    </div>

    <div class="table-wrapper" *ngIf="!isLoading">
      <table mat-table [dataSource]="dataSource" matSort class="wbs-table">
        <ng-container matColumnDef="activity_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Activity</th>
          <td mat-cell *matCellDef="let activity">
            <div class="activity-cell">
              <span class="activity-name">{{ activity.activity_name }}</span>
              <span class="activity-code" *ngIf="activity.activity_code">{{ activity.activity_code }}</span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="plan_dates">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="plan_start_date">Plan</th>
          <td mat-cell *matCellDef="let activity">
            <span class="date-range">{{ formatDateRange(activity.plan_start_date, activity.plan_end_date) }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="actual_dates">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="actual_start_date">Actual</th>
          <td mat-cell *matCellDef="let activity">
            <span class="date-range" [class.date-empty]="!activity.actual_start_date && !activity.actual_end_date">
              {{ formatDateRange(activity.actual_start_date, activity.actual_end_date) }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="percent_complete">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Progress</th>
          <td mat-cell *matCellDef="let activity">
            <span [class]="'completion-badge ' + getCompletionClass(activity.percent_complete)">
              {{ (activity.percent_complete || 0) | number:'1.0-0' }}%
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="assigned_to">
          <th mat-header-cell *matHeaderCellDef>Assigned to</th>
          <td mat-cell *matCellDef="let activity">
            <span *ngIf="activity.assigned_to">{{ activity.assigned_to }}</span>
            <span *ngIf="!activity.assigned_to" class="empty-chip">Unassigned</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="assigned_organization">
          <th mat-header-cell *matHeaderCellDef>Assigned org</th>
          <td mat-cell *matCellDef="let activity">
            <span *ngIf="activity.assigned_organization_name" class="org-chip" [title]="activity.assigned_organization_name">
              {{ activity.assigned_organization_name }}
            </span>
            <span *ngIf="!activity.assigned_organization_name" class="empty-chip">Unassigned</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="actions-col">Actions</th>
          <td mat-cell *matCellDef="let activity" class="actions-col">
            <div class="flex items-center space-x-2">
              <button
                type="button"
                (click)="openEditForm(activity)"
                class="inline-flex items-center p-2 border border-transparent rounded-lg text-blue-600 hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200"
                [matTooltip]="isBidderView ? 'Update progress' : 'Edit activity'"
                matTooltipPosition="above"
              >
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
                </svg>
              </button>
              <button
                *ngIf="!isBidderView"
                type="button"
                (click)="deleteActivity(activity)"
                class="inline-flex items-center p-2 border border-transparent rounded-lg text-red-600 hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-red-500 transition-colors duration-200"
                matTooltip="Delete activity"
                matTooltipPosition="above"
              >
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                </svg>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">
            <div class="no-data">
              <mat-icon>account_tree</mat-icon>
              <p *ngIf="searchTerm">No activities match “{{ searchTerm }}”.</p>
              <p *ngIf="!searchTerm && isBidderView">The parent organization has not allocated WBS activities to you yet.</p>
              <p *ngIf="!searchTerm && !isBidderView">No activities yet. Add one or import from Excel to get started.</p>
              <button *ngIf="!isBidderView && !searchTerm" mat-raised-button color="primary" type="button" (click)="openAddForm()">
                Add Activity
              </button>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>
  </div>
</div>
